import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'objectOrString',
})
export class ObjectOrStringPipe implements PipeTransform {
  transform(value: any, key?: string): string {
    if (key && key.length > 0 && typeof value !== 'string') {
      return value[key];
    } else {
      return value;
    }
  }
}
